import { Type } from './file';

export interface Payload {
  readonly content: string;
}

export enum EmbeddingScope {
  DOC = 'DOC',
  SECTION = 'SECTION',
}

export enum SectionType {
  SUMMARY = 'SUMMARY',
  EXPERIENCE = 'EXPERIENCE',
  EDUCATION = 'EDUCATION',
  SKILLS = 'SKILLS',
  CERTIFICATIONS = 'CERTIFICATIONS',
  OTHER = 'OTHER',
}

export interface ExistedTextContentPayload {
  readonly limit: number;
  readonly portalId: number;
}

export interface ConvertExistedFilesToPdfPayload {
  readonly forceProcessing: boolean;
  readonly limit: number;
  readonly portalId: number;
}

export interface ProcessedResult {
  readonly content: string;
  readonly documentType: string;
  readonly normalizedPdfPath: string;
}

export interface ConvertFileToPdfResponse {
  readonly ok: boolean;
  readonly sha256: string;
  readonly normalizedPdf: string;
  readonly ocr: { ran: boolean; avgConf: number | null };
  readonly mime: string;
}

export interface ClassifyFileResponse {
  readonly ok: boolean;
  readonly class: Type;
  readonly handwritten: boolean;
  readonly textLen: number;
  readonly text: string;
  readonly lang: string;
  readonly confidence: number;
  readonly comment: string;
  readonly source: string;
}
